// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wY","title":"wZ","year":"w0","genres":"w1","buttonWrapper":"w2","button":"w3 y-"};